import styled from 'styled-components';
import { getColor, getFontSize } from '../utils/textHelpers';

export const StyledParagraph = styled.p`
  margin: 0;
  padding: 0;
  color: ${props => getColor(props.theme, props.color)};
  font-size: ${props => getFontSize(props.theme, props.size)};
  font-weight: ${props => props.weight || 'normal'};
  line-height: 1.5;
  font-family: ${props => (props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif'};
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Text/components/TextStyles.js